<template>
  <div class="content-cloud">
    <div class="tagcloud fl">
      <a href="/experts" style="background: #02D088;">行业专家</a><!--radial-gradient(#FADF0E,#02D088)-->
      <a href="/cloudlive" style="background: linear-gradient(to bottom left,#F12655,#154EF7)">云直播</a>
      <a href="/industrystandard" style="background: #F72552">行业标准</a><!--radial-gradient(#04CB9E,#F72552)-->
      <a href="/industryknowledge" style="background: #154EF7">行业知识</a><!--linear-gradient(#F7BB0D,#EF0003)-->
      <a href="/industrymap" style="background: linear-gradient(to bottom left,#FF2524,#442243)">行业图谱</a>
      <a href="/exhibition" style="background: radial-gradient(#BC4DFF,#FF7EF9)">云会展</a>
      <a href="/cloudmall" style="background: linear-gradient(#A02EFF,#0BB0D5)">云商城</a>
      <a href="https://yt.ccf.com.cn/#/outside/pinboard/10001_3hGlDiHbyED4nDycL0yB" target="_blank" style="background: #FD6F4F">进出口细则</a><!--linear-gradient(to bottom left,#FD6F4F,#0AB4D1)-->
      <a href="/custom" style="background: #003EBE">云定制</a><!--linear-gradient(#E9425C,#003EBE)-->
      <a href="/matching" style="background: linear-gradient(#F7BB0D,#EF0003)">撮合交易</a><!--linear-gradient(#E9425C,#003EBE)-->
    </div>
  </div>
</template>

<script>
import '@/views/homeManage/module/tagcloud.js'
export default {
  name: "right-module-one",
  mounted() {
    tagcloud({
      selector: ".tagcloud",  //元素选择器
      fontsize: 16,       //基本字体大小, 单位px
      radius: 100,         //滚动半径, 单位px
      mspeed: "normal",   //滚动最大速度, 取值: slow, normal(默认), fast
      ispeed: "normal",   //滚动初速度, 取值: slow, normal(默认), fast
      direction: 135,     //初始滚动方向, 取值角度(顺时针360): 0对应top, 90对应left, 135对应right-bottom(默认)...
      keep: false          //鼠标移出组件后是否继续随鼠标滚动, 取值: false, true(默认) 对应 减速至初速度滚动, 随鼠标滚动
    });
  }
}
</script>

<style scoped>
.content-cloud {
  display: inline-block;
  width: calc(100% - 67px);
  height: calc(100% - 30px);
  overflow: hidden;
  padding: 10px 0;
  margin:10px 35px 10px 32px;
  background: rgba(0,47,142,.39) url("../../../assets/bj-6.fw.png") no-repeat center/99%;
  border-radius: 9px;
  border:1px solid #002F8E;
}
.tagcloud { position: relative;overflow: hidden;padding: 10px 0;box-sizing: border-box;
  width: 100%;
  height: 100%;}
.tagcloud a{
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  color: #fff;
  font-size: 16px;
  padding: 3px;
  border-radius: 50%;
  max-width: 100px;
  max-height: 100px;
  min-width: 60px;
  min-height: 60px;
  text-align: center;
  background-color: #f2f4f8;
  font-family:"fzskjt";
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 6px 4px 8px 0 rgba(0,0,0,.34);
  text-shadow: 2px 4px 6px rgba(0,0,0,0.6);
  transition: font-size 0.9s ease-out;
  -webkit-transition: font-size 0.9s ease-out;
}
.tagcloud a:hover{
  font-weight: bold;
  font-size: 18px;
  transition: font-size 0s;
  -webkit-transition: font-size 0s;
}
</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/right-module-one.vue